import _typeof from "@babel/runtime/helpers/esm/typeof";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { setCookie, getCookie, cookiesConstants } from '@magalu/mixer-utils';
import { VEHICLE_SEARCH_FILTERS, VEHICLE_ITEMS } from '../constants';
import { createUrlDataObject, parseUrl, slugfyUrl } from '../utils';
export var buildCurrentUrlData = function buildCurrentUrlData(customUrl) {
  var _global, _global$window;
  var location = (_global = global) == null ? void 0 : (_global$window = _global.window) == null ? void 0 : _global$window.location;
  if (!customUrl) {
    var path = location == null ? void 0 : location.pathname;
    var search = location == null ? void 0 : location.search;
    return createUrlDataObject(path, search);
  }
  try {
    var url = parseUrl(customUrl, location);
    return createUrlDataObject(url.pathname, url.search);
  } catch (error) {
    var _path = customUrl.split('?')[0];
    var _search = customUrl.includes('?') ? "".concat(customUrl.split('?')[1]) : '';
    return createUrlDataObject(_path, _search);
  }
};
export var buildRemainingFilters = function buildRemainingFilters(existingFilters, vehicleFilterTypes) {
  return existingFilters.filter(function (filter) {
    var filterType = filter.split('---')[0];
    return !vehicleFilterTypes.includes(filterType);
  });
};
export var buildSearchParams = function buildSearchParams(searchParams) {
  var newSearchParams = new URLSearchParams();
  searchParams.forEach(function (value, key) {
    if (key !== 'filters') newSearchParams.set(key, value);
  });
  return newSearchParams;
};
export var buildVehicleFilterUrl = function buildVehicleFilterUrl(_ref) {
  var selected = _ref.selected,
    vehicleItems = _ref.vehicleItems,
    currentPath = _ref.path,
    searchParams = _ref.searchParams,
    existingFilters = _ref.existingFilters;
  var createVehicleFilters = function createVehicleFilters() {
    if (!selected) return [];
    return vehicleItems.map(function (item) {
      var value = selected[item];
      if (value === null || value === undefined || value === '') {
        return null;
      }
      return {
        type: "car_".concat(item),
        value: slugfyUrl(value)
      };
    }).filter(function (filter) {
      return filter !== null && filter.value;
    });
  };
  var newSearchParams = buildSearchParams(searchParams);
  var vehicleFilters = createVehicleFilters();
  var validFilters = [];
  var vehicleFilterTypes = [];
  vehicleFilters.forEach(function (filter) {
    validFilters.push("".concat(filter.type, "---").concat(filter.value));
    vehicleFilterTypes.push(filter.type);
  });
  var remainingFilters = buildRemainingFilters(existingFilters, vehicleFilterTypes);
  var finalFilters = [].concat(_toConsumableArray(remainingFilters), validFilters);
  if (finalFilters.length > 0) {
    newSearchParams.set('filters', finalFilters.join('+'));
  }
  var queryString = newSearchParams.toString();
  return "".concat(currentPath).concat(queryString ? "?".concat(queryString) : '');
};
export var calcVerticalMarginHelper = function calcVerticalMarginHelper(withSpace) {
  var DEFAULT_MARGIN = '8px';
  if (!withSpace || typeof document === 'undefined') {
    return DEFAULT_MARGIN;
  }
  try {
    var breadcrumb = document.querySelector("[data-testid='breadcrumb-container']");
    var searchFilters = document.querySelector("[data-testid='search-filters']");
    if (!breadcrumb || !searchFilters) {
      return DEFAULT_MARGIN;
    }
    var breadcrumbRect = breadcrumb.getBoundingClientRect();
    var searchFiltersRect = searchFilters.getBoundingClientRect();
    if (!breadcrumbRect || !searchFiltersRect || typeof breadcrumbRect.height !== 'number' || typeof breadcrumbRect.top !== 'number' || typeof searchFiltersRect.top !== 'number') {
      return DEFAULT_MARGIN;
    }
    var marginBetween = Math.abs(searchFiltersRect.top - (breadcrumbRect.height + breadcrumbRect.top));
    return "".concat(marginBetween, "px");
  } catch (error) {
    console.error('Error calculating margin:', error);
    return DEFAULT_MARGIN;
  }
};
export var createSaveToCookie = function createSaveToCookie(cookieDomain) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 1);
    setCookie({
      domain: cookieDomain,
      expires: expiryDate,
      name: cookiesConstants.CARDAN_TRACK_MENU,
      path: '/',
      value: JSON.stringify(data)
    });
  };
};
export var extractFiltersFromUrl = function extractFiltersFromUrl(filtersArray) {
  var filtersMap = {};
  filtersArray.forEach(function (filter) {
    var parts = filter.split('---');
    if (parts.length === 2) {
      var _parts = _slicedToArray(parts, 2),
        type = _parts[0],
        value = _parts[1];
      filtersMap[type] = value;
    }
  });
  return filtersMap;
};
export var getEmptyData = function getEmptyData() {
  return {
    brands: [],
    models: [],
    versions: [],
    years: []
  };
};
export var getEmptySelection = function getEmptySelection() {
  return {
    brand: null,
    brandLogo: null,
    carPlate: null,
    model: null,
    searchUrl: null,
    vehicleDetails: null,
    version: null,
    year: null
  };
};
export var getFromCookie = function getFromCookie() {
  try {
    return getCookie(cookiesConstants.CARDAN_TRACK_MENU);
  } catch (err) {
    console.error('Error reading from cookies:', err);
    return null;
  }
};
var parseSavedData = function parseSavedData(data) {
  if (!data) return {};
  if (_typeof(data) === 'object') {
    return data;
  }
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      try {
        return JSON.parse(decodeURIComponent(data));
      } catch (parseError) {
        return {};
      }
    }
  }
  return {};
};
var inferVersionFromSummaryDescription = function inferVersionFromSummaryDescription(summaryDescription, year) {
  if (typeof summaryDescription !== 'string') return null;
  var normalizedSummary = summaryDescription.replace(/\s+/g, ' ').trim();
  if (!normalizedSummary || !year) return null;
  var yearStr = String(year);
  var indexOfYear = normalizedSummary.indexOf(yearStr);
  if (indexOfYear < 0) return null;
  return normalizedSummary.slice(indexOfYear + yearStr.length).replace(/^[-:|/,\s]+/, '').trim() || null;
};
export var getSavedState = function getSavedState() {
  var _savedData$uiState, _savedData$uiState2;
  var rawSavedData = getFromCookie();
  var savedData = parseSavedData(rawSavedData);
  var savedShowSummary = savedData == null ? void 0 : (_savedData$uiState = savedData.uiState) == null ? void 0 : _savedData$uiState.showSummary;
  var savedSummaryDescription = savedData == null ? void 0 : (_savedData$uiState2 = savedData.uiState) == null ? void 0 : _savedData$uiState2.summaryDescription;
  var selected = (savedData == null ? void 0 : savedData.selected) || getEmptySelection();
  if (!(selected == null ? void 0 : selected.vehicleDetails) && typeof savedSummaryDescription === 'string') {
    var normalizedSummaryDescription = savedSummaryDescription.replace(/\s+/g, ' ').trim();
    if (normalizedSummaryDescription) {
      selected.vehicleDetails = normalizedSummaryDescription;
    }
  }
  if (!(selected == null ? void 0 : selected.version) && savedSummaryDescription) {
    var inferredVersion = inferVersionFromSummaryDescription(savedSummaryDescription, selected == null ? void 0 : selected.year);
    if (inferredVersion) {
      selected.version = inferredVersion;
    }
  }
  return {
    selected: selected,
    uiState: {
      showSummary: typeof savedShowSummary === 'boolean' ? savedShowSummary : false
    }
  };
};
export var isVehicleFilter = function isVehicleFilter(filter) {
  var filterType = filter.split('---')[0];
  return VEHICLE_SEARCH_FILTERS.includes(filterType) || filterType.startsWith('car_');
};
export var hasCleanUrlWithoutCardanFilters = function hasCleanUrlWithoutCardanFilters(existingFilters) {
  try {
    if (!existingFilters || existingFilters.length === 0) {
      return true;
    }
    var hasCardanFilter = existingFilters.some(isVehicleFilter);
    return !hasCardanFilter;
  } catch (error) {
    return true;
  }
};
export var hasMatchingUrlFilters = function hasMatchingUrlFilters(selected, existingFilters) {
  if (!selected) return false;
  try {
    var currentFiltersMap = extractFiltersFromUrl(existingFilters);
    var filterMapping = VEHICLE_ITEMS.reduce(function (acc, item) {
      acc[item] = "car_".concat(item);
      return acc;
    }, {});
    return Object.entries(filterMapping).every(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        stateKey = _ref3[0],
        filterKey = _ref3[1];
      var selectedValue = selected[stateKey];
      if (!selectedValue) return false;
      var urlValue = currentFiltersMap[filterKey];
      return urlValue === slugfyUrl(selectedValue);
    });
  } catch (error) {
    return false;
  }
};
export var removeVehicleFilters = function removeVehicleFilters(urlData) {
  var _ref4 = urlData || {},
    currentPath = _ref4.path,
    searchParams = _ref4.searchParams,
    existingFilters = _ref4.existingFilters;
  if (!currentPath) {
    return '';
  }
  var newSearchParams = buildSearchParams(searchParams || new URLSearchParams());
  var remainingFilters = (existingFilters || []).filter(function (filter) {
    return !isVehicleFilter(filter);
  });
  if (remainingFilters.length > 0) {
    newSearchParams.set('filters', remainingFilters.join('+'));
  }
  var queryString = newSearchParams.toString();
  return "".concat(currentPath).concat(queryString ? "?".concat(queryString) : '');
};
export var scrollToAnchorQuestionButton = function scrollToAnchorQuestionButton() {
  var anchorElement = document.getElementById('question-list-anchor');
  if (anchorElement && (anchorElement == null ? void 0 : anchorElement.scrollIntoView)) {
    anchorElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};